import { Component, OnInit } from '@angular/core';

import { UserService } from '../user.service';
import { AutologoutService } from '../autologout.service';

@Component({
  selector: 'echexpayment-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  
  
  constructor(public autologout: AutologoutService) { 
    autologout.reset();
  }

  ngOnInit() {
  
  }
  
  

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/dashboard/dashboard.component.ts